import {type LexiconDoc} from '@atproto/lexicon'

/**
 * A learner changes their own stage and year. Unlike `putOnboardingData`, it
 * leaves every other onboarding answer as it is.
 */
export const putLearnerLevel: LexiconDoc = {
  lexicon: 1,
  id: 'app.taderok.actor.putLearnerLevel',
  defs: {
    main: {
      type: 'procedure',
      input: {
        encoding: 'application/json',
        schema: {
          type: 'object',
          required: ['learningStage'],
          properties: {
            learningStage: {type: 'string', maxLength: 128},
            gradeLevel: {type: 'string', maxLength: 128},
          },
        },
      },
      output: {
        encoding: 'application/json',
        schema: {
          type: 'object',
          required: ['success'],
          properties: {success: {type: 'boolean'}},
        },
      },
      errors: [{name: 'NotALearner'}],
    },
  },
}
